var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom_card"},[_c('h2',[_vm._v("Page not not found")]),_c('p',[_vm._v(" This page could not be found - go To home "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(". ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }